import CLEClassroom from './CLEClassroom';

export default CLEClassroom;
